
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog-post/2019/05/seo-talk-naturally-good",
      function () {
        return require("private-next-pages/blog-post/2019/05/seo-talk-naturally-good.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog-post/2019/05/seo-talk-naturally-good"])
      });
    }
  